import { render, staticRenderFns } from "./ReviewModeInfo.vue?vue&type=template&id=186048c2&"
import script from "./ReviewModeInfo.vue?vue&type=script&lang=js&"
export * from "./ReviewModeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports